module.exports = __webpack_public_path__ + "img/0Q3A3375_L_Black.8cf32d1b.jpg";